/**
 * Contract between the host app and the `@checkout` app it loads in the checkout iframe.
 *
 * The host builds `#<CHECKOUT_HASH>?product=…&context=…`; `@checkout` reads `context` off the
 * hash query to pick a checkout presentation. Keep the two sides in step — they ship together.
 */
export const CHECKOUT_HASH = "checkout";

export const CHECKOUT_CONTEXT = {
	/** Compact, single-plan checkout shown over the page the user is already on. */
	REACTIVATE: "reactivate",
};
